export default {
  extension: {
    zh: '扩展',
    en: 'Extension',
  },
}
